import { weekdayJp, type PublicEvent } from "../types/public";

/** 開催日 → 時刻 → 会場 → id の順（会場未設定は同日内で末尾） */

export type VenueDateSortable = {
  venue: string | null | undefined;
  event_date: string;
  time_start?: string | null;
  curtain_time?: string | null;
  id?: string;
};

export function compareByDateTimeThenVenue(a: VenueDateSortable, b: VenueDateSortable): number {
  const d = String(a.event_date ?? "").localeCompare(String(b.event_date ?? ""));
  if (d !== 0) return d;
  const ta = String(a.time_start ?? a.curtain_time ?? "").trim();
  const tb = String(b.time_start ?? b.curtain_time ?? "").trim();
  const tc = ta.localeCompare(tb);
  if (tc !== 0) return tc;
  const va = String(a.venue ?? "").trim();
  const vb = String(b.venue ?? "").trim();
  const aUnset = !va;
  const bUnset = !vb;
  if (aUnset !== bUnset) return aUnset ? 1 : -1;
  if (!aUnset) {
    const vc = va.localeCompare(vb, "ja");
    if (vc !== 0) return vc;
  }
  return String(a.id ?? "").localeCompare(String(b.id ?? ""));
}

export function sortByDateTimeThenVenue<T extends VenueDateSortable>(events: T[]): T[] {
  return [...events].sort(compareByDateTimeThenVenue);
}

export function comparePublicEvents(a: PublicEvent, b: PublicEvent): number {
  return compareByDateTimeThenVenue(a, b);
}

/** 開催日ごとに見出しを付けて並べる（日内は時刻→会場順） */
export function groupByEventDate(events: PublicEvent[]): { dateKey: string; heading: string; items: PublicEvent[] }[] {
  const sorted = sortByDateTimeThenVenue(events);
  const out: { dateKey: string; heading: string; items: PublicEvent[] }[] = [];
  for (const e of sorted) {
    const dateKey = e.event_date;
    const heading = `${dateKey}（${weekdayJp(dateKey)}）`;
    const last = out[out.length - 1];
    if (last && last.dateKey === dateKey) last.items.push(e);
    else out.push({ dateKey, heading, items: [e] });
  }
  return out;
}

export type AdminEventRowSortable = Record<string, unknown>;

/** 管理画面：開催日 → 開演時刻 → 会場 → 本番メモ → id */
export function compareAdminEventRows(a: AdminEventRowSortable, b: AdminEventRowSortable): number {
  const da = String(a.event_date ?? "");
  const db = String(b.event_date ?? "");
  const d = da.localeCompare(db);
  if (d !== 0) return d;
  const ta = String(a.time_start ?? a.curtain_time ?? "").trim();
  const tb = String(b.time_start ?? b.curtain_time ?? "").trim();
  const tc = ta.localeCompare(tb);
  if (tc !== 0) return tc;
  const va = String(a.venue ?? "").trim();
  const vb = String(b.venue ?? "").trim();
  const aUnset = !va;
  const bUnset = !vb;
  if (aUnset !== bUnset) return aUnset ? 1 : -1;
  if (!aUnset) {
    const c = va.localeCompare(vb, "ja");
    if (c !== 0) return c;
  }
  const pa = String(a.performance_text ?? "").trim();
  const pb = String(b.performance_text ?? "").trim();
  const pp = pa.localeCompare(pb);
  if (pp !== 0) return pp;
  return String(a.id ?? "").localeCompare(String(b.id ?? ""));
}
